import React, { useContext } from "react";
import CartContext from "../../context/CartContext";
import { StoreContext } from "../../context/StoreContext";
import UserContext from "../../context/UserContext";
import ContactPopup from "../popup/ContactPopup";
import OrderPopup from "../popup/OrderPopup";
import { IoCartOutline } from "react-icons/io5";
import EmptyCartPopup from "../popup/EmptyCartPopup";

const Cart = () => {
  const cartCtx = useContext(CartContext);
  const userCtx = useContext(UserContext);
  const { data } = useContext(StoreContext);
  const storeDetails = data.store_master;
  const totalItem = cartCtx.items.reduce((acc, cur) => acc + cur.qty, 0);

  const handlePageRoute = () => {
    if (totalItem === 0) {
      userCtx.showEmptyCartPopup();
      return;
    }

    if (totalItem > 0) {
      userCtx.goToOrderPage();
      return;
    }

    // exactly 1 item
    userCtx.goToOrderPage();
    setTimeout(() => {
      userCtx.showContactPopup();
    }, 500);
  };


  const handleGoBackFromContact = () => {
    userCtx.goToOrderPage();
  };

  const handleGoBackFromOrder = () => {
    userCtx.goToHomePage();
  };

  return (
    <>
      <div className="floating-cart">
        <div
          className="cart-button"
          onClick={handlePageRoute}
        >
          <div className="cart-icon-wrapper">
            <IoCartOutline className="cart-icon" />
            <span className="cart-item-count">{totalItem}</span>
          </div>
          <span className="cart-text">View Cart</span>
        </div>
      </div>

      {userCtx.isContactPopupShow && <ContactPopup title="Confirm"
        onClose={userCtx.closeAllPopups}
        onGoBack={handleGoBackFromContact} />}
      {userCtx.isOrderPopupShow && (
        <OrderPopup
          onClose={userCtx.closeAllPopups}
          onGoBack={handleGoBackFromOrder}
        />
      )}
      {userCtx.isEmptyCartPopupShow && <EmptyCartPopup onClose={userCtx.closeAllPopups} />}
    </>
  );
};

export default Cart;